import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { enTranslation } from './translations/en';
import { hinTranslation } from './translations/hindi';

i18n.use(LanguageDetector).init({
  resources: {
    en: {
      translations: enTranslation
    },
    hin: {
      translations: hinTranslation
    },
  },
  fallbackLng: "en",
  debug: true,

  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ","
  },
  react: {
    wait: true
  }
});

export default i18n;